import React from 'react';
import { Loader2 } from 'lucide-react';
import './LoadingIndicator.css';

const LoadingIndicator = () => {
  return (
    <div className="loading-indicator">
      <div className="loading-avatar">
        <Loader2 size={20} className="spinning" />
      </div>
      <div className="loading-content">
        <div className="loading-bubble">
          <div className="typing-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <span className="loading-text">AI is thinking...</span>
      </div>
    </div>
  );
};

export default LoadingIndicator;